import { NbMenuItem } from '@nebular/theme';
export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Live Calls',
    icon: 'phone-outline',
    link: '/voicepanel/livecall',
    home: false,
    // navAccess: 'ADMIN'
  },
  {
    title: 'Manage User',
    icon: 'home-outline',
    link: '/voicepanel/manageuser',
    home: false,
    // navAccess: 'ADMIN'
  },
  {
    title: 'Manage Agent',
    icon: 'home-outline',
    link: '/voicepanel/manageagents',
    // navAccess: 'ADMIN',
    home: false,
  },
  {
    title: 'Call Logs',
    icon: 'phone-outline',
    link: '/voicepanel/calllog',
    // navAccess: 'ADMIN,AGENT',
    home: false,
  },
  // {
  //   title: 'Settings',
  //   icon: 'settings-outline',
  //   link: '/voicepanel/settings',
  // },
  // {
  //   title: 'Voice Mail',
  //   icon: 'email-outline',
  //   link: '/voicepanel/voicemail',
  //   home: false,
  // },
  {
    title: 'Black List',
    icon: 'list-outline',
    link: '/voicepanel/blacklist',
    // navAccess: 'ADMIN,AGENT',
    home: false,
  },
  {
    title: 'Click2Call',
    icon: 'phone-outline',
    link: '/voicepanel/click2call',
    // navAccess: 'ADMIN,AGENT',
    home: false,
  },
  {
    title: 'Click2Call Log',
    icon: 'list-outline',
    link: '/voicepanel/click2callLog',
    home: false,
    // navAccess: 'ADMIN,AGENT'
  },
  // {
  //   title: 'Call Flow',
  //   icon: 'phone-outline',
  //   link: '/voicepanel/callflow',
  //   home: false
  // },
  {
    title: 'Office Hours',
    icon: 'clock-outline',
    link: '/voicepanel/officehours',
    home: false,
    // navAccess: 'ADMIN'
  }
];
